<div class="row m-b-xs" (dblclick)="editModeOn()">
    <div *ngIf="title" [class]="classLabel">
        {{ title }}
    </div>

    <div [class]="classValueBox" [class.hidden]="isEditMode">
        <span>{{ value ? (value | mccDate) : '-' }}</span>
        <i *ngIf="!noEdit" class="fa fa-pencil pull-right" (click)="editModeOn()"
           data-toggle="tooltip" data-placement="top" title="Edit"></i>
    </div>

    <div [class]="classValueEditBox" [class.hidden]="!isEditMode">
        <div class="datetime-field-class">
            <mat-form-field>
                <input
                    matInput
                    [min]="minDate"
                    [max]="maxDate"
                    [(ngModel)]="value"
                    (keyup.enter)="apply()"
                    (focus)="picker.open()" (click)="picker.open()"
                    [matDatepicker]="picker" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <button type="button" (click)="apply()">
            <i class="fa fa-check"></i>
        </button>

        <button type="button" (click)="cancel()">
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/components/fields/datetime-field/datetime-field.template.html